import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-[#27272a] text-white overflow-x-hidden" }
const _hoisted_2 = { class: "mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "bg-white rounded-xl p-2 shadow-lg flex items-center justify-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-8 md:grid-cols-2 md:px-6 md:py-14" }
const _hoisted_7 = { class: "flex flex-col justify-center" }
const _hoisted_8 = { class: "mt-8 flex flex-wrap gap-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "lead-card-wrap" }
const _hoisted_11 = { class: "lead-card" }
const _hoisted_12 = { class: "mt-1 text-[12px] text-white/70" }
const _hoisted_13 = { class: "mt-4 flex items-center gap-2" }
const _hoisted_14 = { class: "text-[10px] font-bold text-white/40 ml-2 uppercase tracking-widest" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col gap-6 animate-in slide-in-from-right-4 duration-300"
}
const _hoisted_16 = {
  key: 1,
  class: "flex flex-col gap-6 animate-in slide-in-from-right-4 duration-300"
}
const _hoisted_17 = { class: "field-reset min-w-0" }
const _hoisted_18 = { class: "field-reset min-w-0" }
const _hoisted_19 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_20 = {
  key: 2,
  class: "flex flex-col gap-6 animate-in slide-in-from-right-4 duration-300"
}
const _hoisted_21 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_22 = { class: "mt-4 flex flex-col gap-3" }
const _hoisted_23 = { class: "flex gap-3" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "text-center text-[10px] text-white/40 uppercase tracking-tighter"
}
const _hoisted_26 = { class: "bg-[#18181b] px-6 py-14" }
const _hoisted_27 = { class: "mx-auto max-w-6xl" }
const _hoisted_28 = { class: "mt-10 grid grid-cols-1 gap-6 md:grid-cols-4" }
const _hoisted_29 = { class: "relative h-48 md:h-52 overflow-hidden" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "absolute bottom-4 left-5 text-base md:text-lg font-semibold text-white drop-shadow-lg" }
const _hoisted_32 = { class: "px-6 pb-6 pt-5" }
const _hoisted_33 = { class: "text-xs text-white/70 leading-relaxed space-y-2" }
const _hoisted_34 = { class: "mt-4 flex flex-wrap gap-2" }
const _hoisted_35 = { class: "bg-[#18181b] px-6 pb-16" }
const _hoisted_36 = { class: "mx-auto max-w-6xl" }
const _hoisted_37 = { class: "mt-10 grid grid-cols-1 gap-6 md:grid-cols-4" }
const _hoisted_38 = { class: "relative h-64 overflow-hidden" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = { class: "absolute left-6 bottom-6 text-[17px] font-semibold text-white drop-shadow-xl z-20 leading-tight" }
const _hoisted_41 = { class: "bg-[#18181b] px-6 py-16" }
const _hoisted_42 = { class: "mx-auto max-w-6xl" }
const _hoisted_43 = { class: "grid grid-cols-1 gap-6 md:grid-cols-3" }
const _hoisted_44 = { class: "relative z-10" }
const _hoisted_45 = { class: "text-[17px] font-bold text-white mb-3 group-hover:text-emerald-400 transition-colors duration-300" }
const _hoisted_46 = { class: "text-[14px] text-white/60 leading-relaxed group-hover:text-white/80 transition-colors duration-300" }
const _hoisted_47 = { class: "bg-[#18181b] px-6 pb-16 pt-10" }
const _hoisted_48 = { class: "mx-auto max-w-6xl" }
const _hoisted_49 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8" }
const _hoisted_50 = { class: "text-white/80 text-[15px] leading-relaxed italic relative z-10" }
const _hoisted_51 = { class: "mt-6" }
const _hoisted_52 = { class: "font-bold text-white text-base" }
const _hoisted_53 = { class: "text-xs text-emerald-400/70 uppercase tracking-widest mt-1" }
const _hoisted_54 = { class: "bg-[#18181b] px-6 py-20 border-t border-white/5" }
const _hoisted_55 = { class: "mx-auto max-w-3xl" }
const _hoisted_56 = { class: "mt-10 space-y-5" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 0,
  class: "px-6 pb-6 text-white/60 text-sm leading-relaxed border-t border-white/5 pt-4"
}
const _hoisted_59 = {
  key: 0,
  class: "fixed inset-0 z-[100000] flex items-center justify-center px-4"
}
const _hoisted_60 = { class: "relative w-full max-w-md overflow-hidden rounded-3xl border border-white/10 bg-[#0f1317]/90 p-8 text-center shadow-2xl backdrop-blur-xl" }
const _hoisted_61 = { class: "text-xl font-bold text-white" }
const _hoisted_62 = { class: "mt-3 text-sm leading-relaxed text-white/60" }

import {
  reactive,
  ref,
  defineComponent,
  h,
  onMounted,
  onBeforeUnmount,
  computed,  
} from 'vue'
import { useRouter } from 'vue-router'
import LocationField from '@/components/search/LocationField.vue'
import DateField from '@/components/search/DateField.vue'
import TimeField from '@/components/search/TimeField.vue'
import { getBackendBaseUrl } from '@/utils/common'

import heroImageUrl from '@/assets/landing/saudi/makkah-hero-bg.png'
import vwLogo from '@/assets/logo.png'

// Vehicle & route images
import sClassImg from '@/assets/landing/uae/s-class.jpg'
import vClassImg from '@/assets/landing/uae/v-class.jpg'
import eClassImg from '@/assets/landing/uae/e-class.jpg'
// Using proper GMC image
import gmcImg from '@/assets/landing/saudi/gmc-suv.png'
import saudiImg from '@/assets/landing/uae/saudi.jpg'
import qatarImg from '@/assets/landing/uae/qatar-gcc.jpg'
import europeImg from '@/assets/landing/uae/europe-usa.jpg'

// Unique Saudi Route Images
import jeddahMakkahImg from '@/assets/landing/saudi/jeddah-makkah.png'
import madinahMakkahImg from '@/assets/landing/saudi/madinah-makkah.png'
import makkahMadinahImg from '@/assets/landing/saudi/makkah-madinah.png'
import hotelHaramImg from '@/assets/landing/saudi/hotel-haram.png'

const WHATSAPP_NUMBER = '97332141440' // no +
const whatsappMessage =
  'Hi, I would like to inquire about Saudi Umrah/Ramadan transfers.'


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPageUmrahRamadanSaudi',
  setup(__props) {

const heroImage = heroImageUrl

const suvImg = gmcImg 

const router = useRouter()
const currentStep = ref(1)
const submitting = ref(false)
const carTypeOptions = ['Premium', 'Luxury', 'SUV', 'Van']

const alert = reactive({
  show: false,
  title: 'Attention',
  message: ''
})

const showAlert = (message: string, title = 'Attention') => {
  alert.title = title
  alert.message = message
  alert.show = true
}

const validateAndNext = () => {
  if (currentStep.value === 1) {
    if (!form.name || !form.phone) {
      showAlert('Please enter your full name and a valid contact number so we can reach out with your quote.', 'Incomplete Details')
      return
    }
  } else if (currentStep.value === 2) {
    if (!form.pickup || !form.dropoff || !pickUp.date || !pickUp.time) {
      showAlert('Please provide your pickup location, destination, and preferred date/time to calculate your quote.', 'Trip Info Required')
      return
    }
  }
  currentStep.value++
}

const faqs = reactive([
  {
    q: 'Do you support Umrah pilgrims during Ramadan?',
    a: 'Yes, we specialize in Ramadan and Umrah transfers, providing dedicated coordination and premium vehicles for pilgrims.',
    open: false
  },
  {
    q: 'Can you handle big groups for events in saudi?',
    a: 'Absolutely. We have a fleet of Mercedes V-Class and can arrange multiple vehicles or premium minibuses for larger groups and delegations.',
    open: false
  },
  {
    q: 'Do you provide Meet & Greet at Jeddah & Madinah airports?',
    a: 'Yes, our chauffeurs provide professional Meet & Greet assistance at Jeddah, Madinah, and Riyadh airports.',
    open: false
  },
  {
    q: 'Which vehicles are suitable for families?',
    a: 'The Mercedes V-Class and GMC/SUV are ideal for families, offering ample space for passengers and luggage.',
    open: false
  },
  {
    q: 'Can I book via WhatsApp?',
    a: 'Yes, you can click the WhatsApp button to chat with our team directly for bookings and inquiries.',
    open: false
  }
])

const form = reactive({
  name: '',
  phone: '',
  email: '',
  pickup: '',
  dropoff: '',
  datetime: '',
  notes: '',
  carType: '',
  passengers: 0,
  suitcases: 0,
})

// Whats app
const whatsappUrl = computed(
  () =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`
)

const vehicleCards = [
  {
    name: 'Mercedes S-Class',
    image: sClassImg,
    description: [
      'VIP Umrah guests & dignitaries',
      'Maximum comfort for long journeys'
    ],
    tags: ['3 PASSENGERS', '2 LUGGAGE', 'VIP'],
  },
  {
    name: 'Mercedes V-Class',
    image: vClassImg,
    description: [
      'Families & group pilgrims',
      'Spacious with luggage for Umrah trips'
    ],
    tags: ['5 PASSENGERS', '5 LUGGAGE', 'SPACIOUS'],
  },
  {
    name: 'Mercedes E-Class',
    image: eClassImg,
    description: [
      'Executive & business pilgrims',
      'Comfortable airport transfers'
    ],
    tags: ['3 PASSENGERS', '2 LUGGAGE', 'EXECUTIVE'],
  },
  {
    name: 'GMC / Premium SUV',
    image: suvImg,
    description: [
      'Ideal for road trips Jeddah ↔ Makkah ↔ Madinah',
      'Strong AC, extra luggage space'
    ],
    tags: ['5 PASSENGERS', '4 LUGGAGE', 'PREMIUM SUV'],
  },
]

const routeCards = [
  {
    name: 'Jeddah Airport → Makkah',
    image: jeddahMakkahImg,
  },
  {
    name: 'Madinah Airport → Makkah',
    image: madinahMakkahImg,
  },
  {
    name: 'Makkah ↔ Madinah',
    image: makkahMadinahImg,
  },
  {
    name: 'Hotel ↔ Haram Transfers',
    image: hotelHaramImg,
  },
]

const whyCards = [
  {
    title: 'Saudi Focused Operations',
    copy: 'Dedicated coordination for Umrah & Ramadan travel across the Kingdom.',
  },
  {
    title: 'Premium Fleet Only',
    copy: 'Mercedes & GMC vehicles only – we do not offer economy cars for these services.',
  },
  {
    title: 'Professional Chauffeurs',
    copy: 'Trained for pilgrim travel & religious etiquette, ensuring a respectful journey.',
  },
  {
    title: 'Meet & Greet at Airports',
    copy: 'Full assistance from your arrival at the terminal until you reach your vehicle.',
  },
  {
    title: '24/7 WhatsApp Support',
    copy: 'Live support in Arabic & English whenever you need assistance.',
  },
  {
    title: 'Fixed Transparent Pricing',
    copy: 'No hidden costs or surprises, even during peak Ramadan season.',
  },
]

const pickUp = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } },
  date: null as string | null,
  time: '' as string,
})
const dropOff = reactive({
  location: { id: '', name: '', isAirport: false, coordinates: { lat: null, lng: null } },
})

const onAddressSelected = (address: any, type: 'pickUp' | 'dropOff') => {
  const add = address ?? {
    id: '',
    name: '',
    description: '',
    coordinates: { lat: null, lng: null },
  }
  if (type === 'pickUp') {
    pickUp.location = add
    form.pickup = add?.name || add?.description || ''
  } else {
    dropOff.location = add
    form.dropoff = add?.name || add?.description || ''
  }
}
const onDateChanged = (d: string) => {
  pickUp.date = d
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}
const onTimeChanged = (t: string) => {
  pickUp.time = t
  form.datetime = [pickUp.date, pickUp.time].filter(Boolean).join(' ')
}

const scrollToForm = () => {
  const els = document.querySelectorAll('form')
  if (els && els[0])
    els[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const submitLead = async () => {
  if (!form.name || !form.phone || !form.pickup || !form.dropoff || !form.datetime) {
    showAlert('Some required fields are missing. Please go back and ensure all trip details are filled.', 'Form Error')
    return
  }
  
  const API_BASE = getBackendBaseUrl()
  const payload = {
    name: form.name,
    phone: form.phone,
    email: form.email || null,
    pickup: form.pickup,
    dropoff: form.dropoff,
    datetime: form.datetime,
    notes: form.notes || null,
    source: 'saudi-umrah-ramadan',
    car_type: form.carType || null,
    passengers: Number(form.passengers) || 0,
    suitcases: Number(form.suitcases) || 0,
    pickUp,
    dropOff,
  }

  submitting.value = true
  try {
    const res = await fetch(`${API_BASE}api/leads/airport-transfer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
    if (!res.ok) {
      const msg = await res.text().catch(() => '')
      throw new Error(`Request failed (${res.status}) ${msg}`)
    }
    router.push({ name: 'ThankYou' })
  } catch (e: any) {
    showAlert(e?.message || 'Something went wrong while submitting your request. Please try again or contact us via WhatsApp.', 'Submission Failed')
  } finally {
    submitting.value = false
  }
}

// Google Places dropdown patch (keeps your styling)
function usePatchPacDropdown() {
  let rafId: number | null = null;
  let running = false;
  const getFocusedInput = (): HTMLInputElement | null =>
    document.activeElement?.tagName === 'INPUT'
      ? (document.activeElement as HTMLInputElement)
      : (document.querySelector('.lead-form input:focus') as HTMLInputElement | null)

  const apply = () => {
    const pacs = document.querySelectorAll<HTMLElement>('.pac-container')
    if (!pacs.length) return
    const input = getFocusedInput() || (document.querySelector('.lead-form input') as HTMLInputElement | null)
    if (!input) return
    const r = input.getBoundingClientRect()
    const desiredWidth = Math.max(r.width + 40, 560)
    pacs.forEach(pac => {
      pac.style.setProperty('position', 'fixed', 'important')
      pac.style.setProperty('left', `${r.left}px`, 'important')
      pac.style.setProperty('top', `${r.bottom}px`, 'important')
      pac.style.setProperty('width', `${desiredWidth}px`, 'important')
      pac.style.setProperty('minWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxWidth', `${desiredWidth}px`, 'important')
      pac.style.setProperty('maxHeight', '480px', 'important')
      pac.style.setProperty('overflowY', 'auto', 'important')
      pac.style.setProperty('overflowX', 'hidden', 'important')
      pac.style.setProperty('zIndex', '99999', 'important')
      pac.style.setProperty('borderRadius', '12px', 'important')
      pac.style.setProperty('border', '1px solid rgba(255,255,255,.18)', 'important')
      pac.style.setProperty('background', 'rgba(15,19,23,.98)', 'important')
      pac.style.setProperty('boxShadow', '0 12px 40px rgba(0,0,0,.5)', 'important')
      pac.style.setProperty('padding', '4px 0', 'important')
    })
  }
  const loop = () => { apply(); if (running) rafId = requestAnimationFrame(loop) }
  const start = () => { if (!running) { running = true; loop() } }
  const stop  = () => { running = false; if (rafId) cancelAnimationFrame(rafId); rafId = null }
  const onFocusIn  = () => setTimeout(() => { apply(); start() }, 0)
  const onFocusOut = () => setTimeout(stop, 150)
  const onResize   = () => apply()
  const onScroll   = () => apply()

  onMounted(() => {
    document.addEventListener('focusin', onFocusIn, true)
    document.addEventListener('focusout', onFocusOut, true)
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onScroll, true)
    const mo = new MutationObserver(apply)
    mo.observe(document.body, { childList: true, subtree: true })
  })
  onBeforeUnmount(() => {
    document.removeEventListener('focusin', onFocusIn, true)
    document.removeEventListener('focusout', onFocusOut, true)
    window.removeEventListener('resize', onResize)
    window.removeEventListener('scroll', onScroll, true)
    stop()
  })
}
usePatchPacDropdown()

/* ---------- Lightweight local components ---------- */
const TextField = defineComponent({
  name: 'TextField',
  props: { label: String, modelValue: [String, Number], placeholder: String, type: { type: String, default: 'text' }, min: [String, Number] },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value)
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70 font-semibold' }, props.label),
      h('input', {
        class: 'w-full rounded-xl border border-[var(--lead-border)] bg-[var(--lead-fill)] px-4 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
        style: { height: 'var(--lead-input-h)' },
        value: props.modelValue, placeholder: props.placeholder, onInput,
        type: props.type, min: props.min
      })
    ])
  }
})

const NumberField = defineComponent({
  name: 'NumberField',
  props: { label: String, modelValue: [String, Number], min: { type: [String, Number], default: 0 } },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value === '' ? '' : Number(e.target.value))
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70 font-semibold' }, props.label),
      h('input', {
        class: 'w-full rounded-xl border border-[var(--lead-border)] bg-[var(--lead-fill)] px-4 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
        style: { height: 'var(--lead-input-h)' },
        value: props.modelValue, type: 'number', min: props.min, onInput
      })
    ])
  }
})

const SelectField = defineComponent({
  name: 'SelectField',
  props: { label: String, modelValue: String, options: Array as () => string[], placeholder: String },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onChange = (e: any) => emit('update:modelValue', e.target.value)
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70 font-semibold' }, props.label),
      h('select', {
        class: 'w-full rounded-xl border border-[var(--lead-border)] bg-[var(--lead-fill)] px-4 text-sm outline-none focus:border-white/30',
        style: { height: 'var(--lead-input-h)' },
        value: props.modelValue ?? '',
        onChange
      }, [
        h('option', { value: '' }, props.placeholder || 'Select…'),
        ...(props.options || []).map(o => h('option', { value: o }, o))
      ])
    ])
  }
})

const TextArea = defineComponent({
  name: 'TextArea',
  props: { label: String, modelValue: String, placeholder: String },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const onInput = (e: any) => emit('update:modelValue', e.target.value)
    return () => h('label', { class: 'block', ...attrs }, [
      h('div', { class: 'mb-1 text-[11px] text-white/70 font-semibold' }, props.label),
      h('textarea', {
        class: 'min-h-[120px] w-full rounded-xl border border-[var(--lead-border)] bg-[var(--lead-fill)] p-4 text-sm outline-none placeholder:text-white/30 focus:border-white/30',
        value: props.modelValue, placeholder: props.placeholder, onInput
      })
    ])
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: "relative",
      style: _normalizeStyle({
        backgroundImage: `linear-gradient(rgba(39,39,42,.1), rgba(39,39,42,.88)), url(${_unref(heroImage)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(vwLogo),
              alt: "Vehitra World",
              class: "h-10 w-auto object-contain"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-[15px] opacity-80" }, " 24/7 Support · WhatsApp: +973 3214 1440 ", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createStaticVNode("<span class=\"mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-[12px] font-semibold text-emerald-300 ring-1 ring-white/15\" data-v-0c4a5fe9> ● Premium Saudi Umrah &amp; Ramadan Transfers </span><h1 class=\"leading-tight font-extrabold text-white\" data-v-0c4a5fe9><span class=\"block text-4xl md:text-5xl\" data-v-0c4a5fe9> Premium Ramadan &amp; </span><span class=\"block text-4xl md:text-5xl\" data-v-0c4a5fe9> Umrah Transfers </span><span class=\"block text-4xl md:text-5xl text-emerald-300\" data-v-0c4a5fe9> in Saudi Arabia </span></h1><p class=\"mt-6 max-w-xl text-sm md:text-base text-white/80\" data-v-0c4a5fe9> Luxury chauffeur and airport transfers for Umrah pilgrims, families, VIP travelers, and corporate guests during Ramadan. </p><p class=\"mt-3 max-w-xl text-sm md:text-base text-white/80 font-medium\" data-v-0c4a5fe9> Serving Jeddah, Makkah &amp; Madinah with premium vehicles and trained chauffeurs. </p><div class=\"mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 text-white/80 text-sm\" data-v-0c4a5fe9><div class=\"flex items-center gap-2\" data-v-0c4a5fe9><span class=\"text-emerald-400 text-lg\" data-v-0c4a5fe9>✓</span> 24/7 booking &amp; customer support </div><div class=\"flex items-center gap-2\" data-v-0c4a5fe9><span class=\"text-emerald-400 text-lg\" data-v-0c4a5fe9>✓</span> Airport Meet &amp; Greet assistance </div><div class=\"flex items-center gap-2\" data-v-0c4a5fe9><span class=\"text-emerald-400 text-lg\" data-v-0c4a5fe9>✓</span> Professional, licensed chauffeurs </div><div class=\"flex items-center gap-2\" data-v-0c4a5fe9><span class=\"text-emerald-400 text-lg\" data-v-0c4a5fe9>✓</span> Clean, premium vehicles </div><div class=\"flex items-center gap-2\" data-v-0c4a5fe9><span class=\"text-emerald-400 text-lg\" data-v-0c4a5fe9>✓</span> Fixed &amp; transparent pricing </div><div class=\"flex items-center gap-2\" data-v-0c4a5fe9><span class=\"text-emerald-400 text-lg\" data-v-0c4a5fe9>✓</span> On-time, safe, and comfortable travel </div></div>", 5)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: scrollToForm,
              class: "inline-flex items-center justify-center rounded-full bg-emerald-500 px-6 py-3 text-sm font-semibold text-[#050708] transition hover:bg-emerald-400"
            }, " Get Instant Quote "),
            _createElementVNode("a", {
              href: whatsappUrl.value,
              target: "_blank",
              class: "inline-flex items-center justify-center rounded-full border border-white/20 px-5 py-3 text-sm font-semibold text-white/90 hover:bg-white/5"
            }, " WhatsApp Our Team ", 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-[20px] font-semibold" }, "Get a Quote for Saudi Umrah Transfers", -1)),
            _createElementVNode("p", _hoisted_12, " Complete the " + _toDisplayString(currentStep.value === 3 ? 'final ' : '') + "step to get your priority confirmed quote. ", 1),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (step) => {
                return _createElementVNode("div", {
                  key: step,
                  class: _normalizeClass(["h-1.5 flex-1 rounded-full transition-all duration-500", step <= currentStep.value ? 'bg-emerald-500' : 'bg-white/10'])
                }, null, 2)
              }), 64)),
              _createElementVNode("span", _hoisted_14, "Step " + _toDisplayString(currentStep.value) + "/3", 1)
            ]),
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitLead, ["prevent"]),
              class: "lead-form mt-6 flex flex-col gap-6"
            }, [
              (currentStep.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_unref(TextField), {
                      label: "Full Name",
                      placeholder: "e.g. John Doe",
                      modelValue: form.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(TextField), {
                      label: "Mobile / WhatsApp Number",
                      placeholder: "+966 5X XXX XXXX",
                      modelValue: form.phone,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.phone) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(TextField), {
                      label: "Email Address",
                      placeholder: "name@company.com",
                      modelValue: form.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (currentStep.value === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(LocationField, {
                        class: "field-reset af-loc",
                        layout: 'simple',
                        drive: 'distance',
                        hasError: false,
                        data: pickUp,
                        type: "pickUp",
                        label: "Pickup Location (Airport / Hotel)",
                        onAddressSelected: _cache[3] || (_cache[3] = addr => onAddressSelected(addr, 'pickUp'))
                      }, null, 8, ["data"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(LocationField, {
                        class: "field-reset af-loc",
                        layout: 'simple',
                        drive: 'distance',
                        hasError: false,
                        data: dropOff,
                        type: "dropOff",
                        label: "Destination (Makkah / Madinah / City)",
                        onAddressSelected: _cache[4] || (_cache[4] = addr => onAddressSelected(addr, 'dropOff'))
                      }, null, 8, ["data"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(DateField, {
                        class: "field-reset af-dt",
                        layout: 'simple',
                        hasError: false,
                        data: pickUp.date,
                        label: "Pickup Date",
                        onDateChanged: onDateChanged
                      }, null, 8, ["data"]),
                      _createVNode(TimeField, {
                        class: "field-reset af-dt",
                        layout: 'simple',
                        hasError: false,
                        data: pickUp.time,
                        label: "Pickup Time",
                        onTimeChanged: onTimeChanged
                      }, null, 8, ["data"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (currentStep.value === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_unref(SelectField), {
                      label: "Preferred Vehicle (Optional)",
                      modelValue: form.carType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.carType) = $event)),
                      options: carTypeOptions,
                      placeholder: "Choose vehicle type"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_unref(NumberField), {
                        label: "No. of Passengers",
                        modelValue: form.passengers,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.passengers) = $event)),
                        modelModifiers: { number: true },
                        min: "0"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(NumberField), {
                        label: "No. of Suitcases",
                        modelValue: form.suitcases,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.suitcases) = $event)),
                        modelModifiers: { number: true },
                        min: "0"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(TextArea), {
                      label: "Additional Notes (Optional)",
                      placeholder: "Flight number, child seat, special requests...",
                      modelValue: form.notes,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.notes) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (currentStep.value > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (currentStep.value--)),
                        class: "flex-1 rounded-full border border-white/20 px-6 py-4 text-[15px] font-bold text-white transition hover:bg-white/5 active:scale-95"
                      }, " Back "))
                    : _createCommentVNode("", true),
                  (currentStep.value < 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        onClick: validateAndNext,
                        class: "flex-[2] rounded-full bg-emerald-500 px-6 py-4 text-[15px] font-bold text-[#050708] shadow-lg shadow-emerald-500/20 transition hover:bg-emerald-400 active:scale-95"
                      }, " Continue to Step " + _toDisplayString(currentStep.value + 1), 1))
                    : _createCommentVNode("", true),
                  (currentStep.value === 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "submit",
                        disabled: submitting.value,
                        class: "flex-[2] btn-primary py-4 text-[15px]"
                      }, _toDisplayString(submitting.value ? 'Submitting…' : 'Get Quote'), 9, _hoisted_24))
                    : _createCommentVNode("", true)
                ]),
                (currentStep.value === 3)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Instant confirmation via WhatsApp following submission "))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ])
        ])
      ])
    ], 4),
    _createElementVNode("section", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Choose Your Vehicle "),
          _createElementVNode("p", { class: "mt-3 text-sm md:text-base text-zinc-300" }, " Select the ideal vehicle class for your Umrah journey and transfers. ")
        ], -1)),
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(vehicleCards, (car) => {
            return _createElementVNode("article", {
              key: car.name,
              class: "overflow-hidden rounded-3xl bg-[#27272a] border border-white/5 shadow-[0_24px_60px_rgba(0,0,0,.4)] transition-all duration-500 hover:border-white/10"
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("img", {
                  src: car.image,
                  alt: car.name,
                  class: "h-full w-full object-cover"
                }, null, 8, _hoisted_30),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" }, null, -1)),
                _createElementVNode("h3", _hoisted_31, _toDisplayString(car.name), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("ul", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(car.description, (desc) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: desc,
                      class: "flex gap-2"
                    }, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-emerald-400 italic" }, "●", -1)),
                      _createTextVNode(" " + _toDisplayString(desc), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(car.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white/60"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ])
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-left" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Popular Ramadan & Umrah Routes "),
          _createElementVNode("p", { class: "mt-3 text-sm md:text-base text-zinc-300" }, " Dedicated transfers between airports and holy cities. ")
        ], -1)),
        _createElementVNode("div", _hoisted_37, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routeCards, (route) => {
            return _createElementVNode("article", {
              key: route.name,
              class: "overflow-hidden rounded-3xl bg-[#27272a] border border-white/5 shadow-[0_24px_60px_rgba(0,0,0,.4)] transition-all duration-500"
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("img", {
                  src: route.image,
                  alt: route.name,
                  class: "h-full w-full object-cover"
                }, null, 8, _hoisted_39),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" }, null, -1)),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "absolute left-6 top-6 flex items-center gap-2 z-20" }, [
                  _createElementVNode("span", { class: "rounded-xl border border-emerald-400/50 bg-emerald-950/80 px-3 py-1 text-[10px] font-bold text-emerald-300 backdrop-blur-md shadow-lg" }, " Highly Recommended ")
                ], -1)),
                _createElementVNode("h3", _hoisted_40, _toDisplayString(route.name), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-center mb-10" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Why Choose Vehitra World "),
          _createElementVNode("p", { class: "mt-3 text-sm md:text-base text-zinc-300" }, " Trusted partner for premium ground transportation in Saudi Arabia. ")
        ], -1)),
        _createElementVNode("div", _hoisted_43, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(whyCards, (item) => {
            return _createElementVNode("div", {
              key: item.title,
              class: "why-card group relative p-8 rounded-3xl overflow-hidden"
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "absolute inset-0 bg-white/[0.03] backdrop-blur-md border border-white/10 group-hover:bg-white/[0.06] group-hover:border-white/20 transition-all duration-500" }, null, -1)),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute -inset-px bg-gradient-to-br from-emerald-500/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" }, null, -1)),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("h3", _hoisted_45, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_46, _toDisplayString(item.copy), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-12 text-center" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " What Our Clients Say "),
          _createElementVNode("div", { class: "mt-2 mx-auto w-24 h-1 bg-emerald-500 rounded-full" }),
          _createElementVNode("p", { class: "mt-4 text-sm md:text-base text-zinc-400" }, " Providing peace of mind for pilgrims and travelers across the Kingdom. ")
        ], -1)),
        _createElementVNode("div", _hoisted_49, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { quote: 'Flawless coordination for our Umrah group. The Mercedes V-Class was perfect for the family and luggage.', author: 'Umrah Travel Agent', location: 'Jeddah' },
              { quote: 'Exceptional meet and greet service at Jeddah airport. The chauffeur was professional and very helpful.', author: 'Family Pilgrim (VIP)', location: 'Makkah' },
              { quote: 'Regularly use Vehitra for our corporate transfers in Riyadh and Madinah. Timely and high-quality vehicles.', author: 'Corporate Delegate', location: 'Riyadh' }
            ], (testimonial, tIdx) => {
            return _createElementVNode("div", {
              key: tIdx,
              class: "relative p-8 rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-md hover:border-emerald-500/30 transition-all duration-300"
            }, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "absolute top-6 right-8 text-4xl text-emerald-500/20 font-serif" }, "“", -1)),
              _createElementVNode("p", _hoisted_50, " “" + _toDisplayString(testimonial.quote) + "” ", 1),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, _toDisplayString(testimonial.author), 1),
                _createElementVNode("div", _hoisted_53, _toDisplayString(testimonial.location), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-center mb-12" }, [
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white" }, " Frequently Asked Questions "),
          _createElementVNode("div", { class: "mt-2 mx-auto w-24 h-1 bg-emerald-500 rounded-full" })
        ], -1)),
        _createElementVNode("div", _hoisted_56, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs, (faq, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: _normalizeClass(["rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur-sm overflow-hidden", faq.open ? 'border-emerald-500/30 bg-white/[0.04]' : ''])
            }, [
              _createElementVNode("button", {
                class: "w-full flex justify-between items-center px-6 py-5 text-left transition-colors",
                onClick: ($event: any) => (faq.open = !faq.open)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["font-bold text-[15px] transition-colors", faq.open ? 'text-emerald-400' : 'text-white/90'])
                }, _toDisplayString(faq.q), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-emerald-500 transition-transform duration-300", faq.open ? 'rotate-180' : ''])
                }, " ▼ ", 2)
              ], 8, _hoisted_57),
              (faq.open)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(faq.a), 1))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", { class: "bg-[#27272a] px-6 py-20 relative overflow-hidden" }, [
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "pointer-events-none absolute inset-0 flex items-center justify-center" }, [
        _createElementVNode("div", { class: "h-[600px] w-[600px] rounded-full bg-emerald-600/10 blur-[160px]" })
      ], -1)),
      _createElementVNode("div", { class: "mx-auto max-w-4xl text-center relative z-10" }, [
        _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "text-3xl md:text-4xl font-extrabold text-white leading-tight" }, [
          _createTextVNode(" Planning Your "),
          _createElementVNode("span", { class: "text-emerald-400" }, "Umrah or Ramadan Travel"),
          _createTextVNode(" in Saudi Arabia? ")
        ], -1)),
        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "mx-auto mt-4 max-w-2xl text-white/70 text-sm md:text-base leading-relaxed" }, " Book premium airport and intercity transfers with confidence. ", -1)),
        _createElementVNode("button", {
          onClick: scrollToForm,
          class: "mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-8 py-4 text-base font-semibold text-[#020617] shadow-lg shadow-emerald-500/30 hover:bg-emerald-400 transition"
        }, _cache[27] || (_cache[27] = [
          _createTextVNode(" Get Instant Quote "),
          _createElementVNode("span", { class: "text-xl" }, "↗", -1)
        ]))
      ])
    ]),
    _cache[32] || (_cache[32] = _createElementVNode("footer", { class: "bg-[#121212] px-6 py-8 border-t border-white/10" }, [
      _createElementVNode("div", { class: "mx-auto max-w-6xl text-center text-[12px] text-white/40" }, [
        _createTextVNode(" © 2025 Vehitra World • All Rights Reserved "),
        _createElementVNode("br"),
        _createElementVNode("span", { class: "text-white/30" }, "Privacy Policy · Terms · Contact")
      ])
    ], -1)),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "opacity-0 scale-95",
      "enter-to-class": "opacity-100 scale-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (alert.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-black/60 backdrop-blur-sm",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (alert.show = false))
              }),
              _createElementVNode("div", _hoisted_60, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-400" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-8 w-8",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    })
                  ])
                ], -1)),
                _createElementVNode("h3", _hoisted_61, _toDisplayString(alert.title), 1),
                _createElementVNode("p", _hoisted_62, _toDisplayString(alert.message), 1),
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (alert.show = false)),
                  class: "mt-8 w-full rounded-full bg-emerald-500 py-4 text-sm font-bold text-[#050708] shadow-lg shadow-emerald-500/20 transition hover:bg-emerald-400 active:scale-95"
                }, " Got it, thanks ")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})